// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__17qht","actionsCol":"EnrolledClinics_actionsCol__2oGuG"};